import React from 'react';
import PageTemplate from './PageTemplate';
import RecordEditor from '../components/records/RecordEditor';
import { useSearchParams } from 'react-router-dom';
import { WaterLevel } from '../types/CanyonRecord';
import { useTranslation } from 'react-i18next';

const RecordPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const { t } = useTranslation();
    const canyonId = searchParams.get('canyonId');
    const userCanyonId = searchParams.get('userCanyonId');

    const initialValues = canyonId || userCanyonId ? {
        Date: new Date().toISOString().split('T')[0],
        TeamSize: undefined, Comments: '', RopeIds: [], GearIds: [],
        CanyonId: canyonId ? parseInt(canyonId, 10) : undefined,
        UserCanyonId: userCanyonId ? parseInt(userCanyonId, 10) : undefined,
        WaterLevel: WaterLevel.Unknown
    } : undefined;

    console.log(searchParams, canyonId, initialValues);

    return (
        <PageTemplate pageTitle={t('common:actions.recordDescent')} isAuthRequired>
            <RecordEditor isEdit={false} initialValues={initialValues} />
        </PageTemplate>
    );
};

export default RecordPage;

